module.exports = __webpack_public_path__ + "static/media/DLN-dark.f4fc5567.png";